<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />
    <loading v-if="vLoading" />

    <v-col lg="12" class="ml-auto"></v-col>
    <b-card
      v-if="$router.currentRoute.path == '/shop/payments'"
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <template v-slot:header>
        <v-row>
          <v-col>
            <h5 class="m-0 pt-1">مدیریت دریافت‌ها</h5>
          </v-col>
          <v-col>
            <v-btn style="float: left" @click="shopNewPaymentDialog()">
              ثبت جدید +
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <br />
      <b-card class="shadow p-3 mb-5 bg-white rounded">
        <template v-slot:header>
          <v-row class="p-0">
            <v-col cols="4">
              <date-picker
                placeholder="تاریخ شروع"
                v-model="startDate"
                :editable="true"
              ></date-picker
            ></v-col>
            <v-col cols="4">
              <date-picker
                placeholder="تاریخ پایان"
                v-model="endDate"
                :editable="true"
              ></date-picker></v-col
            ><v-col cols="4">
              <b-btn class="btn btn-dark" @click="searchPayments()"
                >جستجو</b-btn
              >
            </v-col>
          </v-row>
        </template>
        <v-row class="p-0">
          <v-col cols="12" class="pb-0 mt-3">
            <v-text-field
              v-model="userInput"
              placeholder="جستجو"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <b-table
          responsive
          show-empty
          :items="payments"
          :fields="fields"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="رکوردی برای نمایش وجود ندارد"
          striped
          :current-page="currentPage"
          :per-page="perPage"
          :busy="isBusy"
          :filter="userInput"
          id="payments-table"
          @filtered="onFiltered"
        >
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(shopCustomerName)="data">
            <div style="text-align: center; vertical-align: middle">
              <router-link :to="'/shop/customer/' + data.item.shopCustomerId"
                >{{ data.value }} ({{
                  data.item.shopCustomerCode
                }})</router-link
              >
            </div>
          </template>
          <template v-slot:cell(amount)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value.toLocaleString() }} ریال
            </div>
          </template>
          <template v-slot:cell(description)="data">
            <div style="text-align: center; vertical-align: middle">
              {{
                data.value.length > 100
                  ? data.value.slice(0, 100) + "..."
                  : data.value
              }}
            </div>
          </template>
          <template v-slot:cell(date)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value + "-" + data.item.time }}
            </div>
          </template>
          <template v-slot:cell(operation)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-btn
                :disabled="gettingReceipt"
                class="mr-1"
                variant="primary"
                @click="openPrint(data.item)"
                >چاپ رسید</b-btn
              >
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 + perPage * (currentPage - 1) }}
            </div>
          </template>
          <div slot="table-busy" class="text-center text-danger my-2">
            <strong>در حال بارگذاری...</strong>
            <br />
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </b-table>

        <b-pagination
          v-model="currentPage"
          :total-rows="TotalRows"
          :per-page="perPage"
          aria-controls="payments-table"
          align="center"
          size="md"
          class="my-0"
        ></b-pagination>
      </b-card>
      <br />
    </b-card>

    <v-dialog v-model="newPaymentDialog" max-width="600px">
      <v-card style="overflow-y: scroll" max-height="80vh">
        <v-card-title>
          <h4>ثبت دریافت جدید</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-autocomplete
              @change="getBalance(newPayment.shopCustomerId)"
              auto-select-first
              no-data-text="نتیجه‌ای یافت نشد!"
              v-model="newPayment.shopCustomerId"
              :items="customers"
              item-text="name"
              item-value="id"
              class="p-0"
              label="نام مشتری"
              dense
              outlined
            ></v-autocomplete>
            <p v-if="newPayment.shopCustomerId">
              مانده حساب مشتری:
              <span v-if="newPayment.customerBalance">{{
                newPayment.customerBalance
              }}</span>
              <b-spinner v-else></b-spinner>
            </p>
            <v-text-field
              outlined
              dense
              label="مبلغ دریافت"
              :loading="progress"
              v-model="newPayment.totalCost"
              @keyup.enter="addPayment()"
            ></v-text-field>
            <p>
              {{
                newPayment.totalCost
                  ? Number(newPayment.totalCost).toLocaleString() + "ریال"
                  : ""
              }}
            </p>
            <v-select
              label="نوع دریافت"
              :items="paymentTypes"
              v-model="newPayment.paymentTypes"
              outlined
              dense
            />
            <p v-if="newPayment.paymentTypes == 'cash'">
              <v-textarea
                outlined
                dense
                label="توضیحات"
                rows="3"
                v-model="newPayment.description"
              ></v-textarea>
            </p>
            <p v-if="newPayment.paymentTypes == 'card'">
              <v-textarea
                outlined
                dense
                label="توضیحات"
                rows="3"
                v-model="newPayment.description"
              ></v-textarea>
            </p>
            <br />
            <div
              v-if="newPayment.paymentTypes == 'cheque'"
              class="pa-5 pt-10 mb-2"
              style="
                border: 1px solid #ccc;
                border-radius: 7px;
                position: relative;
              "
            >
              <p
                class="px-4"
                style="position: absolute; top: -9px; background-color: #fff"
              >
                اطلاعات چک را وارد کنید:
              </p>
              <v-row>
                <v-col class="py-0">
                  <v-text-field
                    label="* شماره چک"
                    v-model="check.number"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>

                <v-col class="py-0">
                  <v-text-field
                    label="* نام بانک"
                    v-model="check.bankName"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    label="شماره صیاد"
                    v-model="check.chequeSayyad"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0">
                  <label>* تاریخ چک</label>
                  <date-picker
                    v-model="check.date"
                    :editable="true"
                  ></date-picker>
                </v-col>
                <v-col class="pt-0" cols="12">
                  <v-textarea
                    outlined
                    dense
                    label="توضیحات"
                    rows="3"
                    v-model="newPayment.description"
                  ></v-textarea>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="newPaymentDialog = false"
          >
            لغو
          </v-btn>
          <v-btn color="primary" @click="addPayment()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <br />

    <!-- receipt -->
    <v-card v-show="false" id="Receipt">
      <div class="container mb-0" style="border: 2px solid rgb(200, 200, 200)">
        <div style="text-align: center">
          <span style="font-size: 22px">فروشگاه پولاد پیچکار</span>
        </div>
        <hr />
        <div style="padding: 0 15px">
          <div style="direction: rtl">
            <div
              style="
                border: 1px solid black;
                border-radius: 10px;
                padding: 0 10px;
                min-height: 120px;
                margin-bottom: 10px;
              "
            >
              <div style="text-align: center">
                <span style="font-size: 20px"
                  >رسید
                  {{
                    newPayment.paymentTypes == "cheque" ? "چک" : "دریافت"
                  }}</span
                >
              </div>
              <br />
              <table style="border: 0px solid black !important">
                <tr>
                  <td style="border: 0px solid black !important">
                    نام مشتری:
                    {{
                      newPayment.shopCustomerId
                        ? customers.filter(
                            (x) => x.id == newPayment.shopCustomerId
                          )[0].name
                        : "-"
                    }}
                  </td>
                  <td
                    style="border: 0px solid black !important; text-align: left"
                  >
                    تاریخ: {{ moment(new Date()).format("jYYYY/jMM/jDD") }}
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px solid black !important">
                    کد مشتری:
                    {{
                      newPayment.shopCustomerId
                        ? customers.filter(
                            (x) => x.id == newPayment.shopCustomerId
                          )[0].customerCode
                        : "-"
                    }}
                  </td>
                  <td
                    style="border: 0px solid black !important; text-align: left"
                  >
                    ساعت: {{ moment(new Date()).format("HH:mm") }}
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px solid black !important">
                    نوع مشتری:
                    {{
                      newPayment.shopCustomerId
                        ? customers.filter(
                            (x) => x.id == newPayment.shopCustomerId
                          )[0].type
                        : "-"
                    }}
                  </td>
                </tr>
              </table>

              <br />
            </div>
            <div style="padding: 0 10px">
              <table style="border: 0px solid black !important">
                <tr>
                  <td style="border: 0px solid black !important">
                    مبلغ دریافت:
                    {{ Number(newPayment.totalCost).toLocaleString() }} ریال
                  </td>
                  <td
                    v-if="
                      newPayment.shopCustomerId &&
                      newPayment.paymentTypes != 'cheque'
                    "
                    style="border: 0px solid black !important; text-align: left"
                  >
                    شیوه دریافت:
                    {{
                      newPayment.paymentTypes == "cash" ? "نقدی" : "کارتخوان"
                    }}
                  </td>
                </tr>
              </table>

              <!-- <span v-if="newPayment.shopCustomerId">
                مانده حساب قبلی مشتری:
                <span
                  v-if="newPayment.customerBalance"
                  style="text-align: left"
                  >{{ newPayment.customerBalance }}</span
                >
              </span> -->

              <br />
              <!-- مانده: {{ customerNewBalance }}-->
            </div>
            <hr v-if="newPayment.paymentTypes == 'cheque'" />
            <div style="padding: 0 10px">
              <table style="border: 0px solid black !important">
                <tr>
                  <td
                    v-if="newPayment.paymentTypes == 'cheque'"
                    style="border: 0px solid black !important"
                  >
                    <span>{{ "شیوه دریافت: چک" }}</span>
                  </td>
                  <td
                    v-if="newPayment.paymentTypes == 'cheque'"
                    style="border: 0px solid black !important"
                  >
                    <span>{{ "شماره چک: " + check.number }}</span>
                  </td>
                </tr>
                <tr>
                  <td
                    v-if="newPayment.paymentTypes == 'cheque'"
                    style="border: 0px solid black !important"
                  >
                    <span>{{ "نام بانک: " + check.bankName }}</span>
                  </td>
                  <td
                    v-if="newPayment.paymentTypes == 'cheque'"
                    style="border: 0px solid black !important"
                  >
                    <span>{{ "تاریخ چک: " + check.date }}</span>
                  </td>
                </tr>
                <tr>
                  <td
                    v-if="newPayment.paymentTypes == 'cheque'"
                    style="border: 0px solid black !important"
                  >
                    <span>{{
                      "شماره صیاد: " +
                      (check.chequeSayyad ? check.chequeSayyad : "-")
                    }}</span>
                  </td>
                </tr>
              </table>
            </div>
            <br />
            <div
              style="
                border: 1px solid grey;
                border-radius: 10px;
                min-height: 80px;
                padding: 10px;
                break-inside: avoid;
              "
            >
              <span>توضیحات: {{ newPayment.description }}</span>
            </div>
            <br />
          </div>
        </div>
      </div>
    </v-card>
    <v-card class="pa-2" style="float: left" v-show="false" id="oldReceipt">
      <div class="container mb-0" style="border: 2px solid rgb(200, 200, 200)">
        <div style="text-align: center">
          <span style="font-size: 22px">فروشگاه پولاد پیچکار</span>
        </div>
        <hr />

        <div style="padding: 0 15px">
          <div style="direction: rtl">
            <div
              style="
                border: 1px solid black;
                border-radius: 10px;
                padding: 0 10px;
                min-height: 120px;
                margin-bottom: 10px;
              "
            >
              <div style="text-align: center">
                <span style="font-size: 18px">
                  رسید {{ printPayment.type == "چک" ? "چک" : "دریافت" }} (چاپ
                  مجدد)
                </span>
              </div>
              <br />
              <table style="border: 0px solid black !important">
                <tr>
                  <td style="border: 0px solid black !important">
                    نام مشتری:
                    {{ printPayment.shopCustomerName }}
                  </td>
                  <td
                    style="border: 0px solid black !important; text-align: left"
                  >
                    تاریخ:
                    {{
                      printPayment.date ? printPayment.date.split(" ")[0] : ""
                    }}
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px solid black !important">
                    کد مشتری:
                    {{ printPayment.shopCustomerCode }}
                  </td>
                  <td
                    style="border: 0px solid black !important; text-align: left"
                  >
                    ساعت:
                    {{
                      printPayment.date ? printPayment.date.split(" ")[1] : ""
                    }}
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px solid black !important">
                    نوع مشتری:
                    {{ printPayment.shopCustomerType }}
                  </td>
                </tr>
              </table>

              <br />
            </div>
            <div style="padding: 0 10px">
              <span v-if="printPayment.type != 'چک'">
                شیوه دریافت:
                {{ printPayment.type }}
              </span>
              <br />
              <!-- <span>
                مانده حساب قبلی مشتری:
                <span
                  v-if="newPayment.customerBalance"
                  style="text-align: left"
                  >{{ newPayment.customerBalance }}</span
                >
              </span> -->
              مبلغ دریافت:
              {{ printPayment.amount }} ریال
              <br />
              <!--  مانده: {{ customerNewBalance }} -->
              <hr v-if="printPayment.type == 'چک'" />
              <table style="border: 0px solid black !important">
                <tr>
                  <td
                    v-if="printPayment.type == 'چک'"
                    style="border: 0px solid black !important"
                  >
                    <span>{{ "شیوه دریافت: " + printPayment.type }}</span>
                  </td>
                  <td
                    v-if="printPayment.type == 'چک'"
                    style="border: 0px solid black !important"
                  >
                    <span>{{ "شماره چک: " + printPayment.chequeNo }}</span>
                  </td>
                </tr>
                <tr>
                  <td
                    v-if="printPayment.type == 'چک'"
                    style="border: 0px solid black !important"
                  >
                    <span>{{ "نام بانک: " + printPayment.chequeBank }}</span>
                  </td>
                  <td
                    v-if="printPayment.type == 'چک'"
                    style="border: 0px solid black !important"
                  >
                    <span>{{ "تاریخ چک: " + printPayment.chequeDate }}</span>
                  </td>
                </tr>
                <tr>
                  <td
                    v-if="printPayment.type == 'چک'"
                    style="border: 0px solid black !important"
                  >
                    <span>{{
                      "شماره صیاد: " + printPayment.chequeSayyad
                    }}</span>
                  </td>
                </tr>
              </table>
            </div>
            <br />
            <div
              style="
                border: 1px solid grey;
                border-radius: 10px;
                min-height: 80px;
                padding: 10px;
                break-inside: avoid;
              "
            >
              <span>توضیحات: {{ printPayment.description }}</span>
            </div>
            <br />
          </div>
        </div>
      </div>
    </v-card>
    <!-- receipt -->

    <router-view></router-view>
  </div>
</template>

<script>
import Axios from "axios";
import Var from "../../../variables";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import router from "../../router";
import moment from "moment-jalaali";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },

  data: function () {
    return {
      guide: false,

      moment: moment,
      startDate: moment(new Date()).subtract(2, "days").format("jYYYY/jMM/jDD"),
      endDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      fields: [
        { key: "index", label: "ردیف" },
        { key: "shopCustomerName", label: "نام مشتری" },
        { key: "date", label: "تاریخ دریافت" },
        { key: "type", label: "نوع دریافت" },
        { key: "description", label: "توضیحات" },
        { key: "amount", label: "مبلغ" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      paymentTypes: [
        { value: "cash", text: "نقدی" },
        { value: "card", text: "کارتخوان" },
        { value: "cheque", text: "چک" },
      ],
      customers: [],
      customerName: "",
      customerPriority: "",
      customerMobile: "",
      customerEmail: "",
      customerDialog: false,
      userInput: "",
      currentPage: 1,
      perPage: 10,
      TotalRows: 1,
      striped: true,
      selectedCustomer: {},
      isBusy: true,
      filter: null,
      gettingReceipt: false,
      payments: [],
      selected: "",
      newPaymentDialog: false,
      newPayment: {
        customerBalance: "",
        totalCost: 0,
      },
      progress: false,
      customer: {},
      customerOldBalance: 0,
      customerNewBalance: 0,
      printPayment: {},
      check: {},
      printPaymentIncome: {},
    };
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    delFilter() {
      // this.sortBy = "";
      this.userInput = "";
      // this.isBusy = true;
      // this.searchPayments();
    },
    openPrint(item) {
      this.print(item);
      this.getBalance(item.shopCustomerId);
    },
    shopNewPaymentDialog() {
      this.newPayment = {
        customerBalance: "",
        totalCost: 0,
      };
      this.newPaymentDialog = true;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    print(item) {
      this.gettingReceipt = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/payments/getInfo",
        {
          shopIncomeId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingReceipt = false;
          if (res.status == 200) {
            this.printPayment = res.data;
            this.printPaymentIncome = res.data.income;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .then(() => {
          this.printReceipt("old");
        })
        .catch((err) => {
          this.gettingReceipt = false;
          this.toast(err.response.data, "error");
        });
    },
    getBalance(customerId) {
      this.newPayment.customerBalance = "";
      Axios.post(
        this.baseUrl + "/ppkpms/shop/payments/customerBalance",
        {
          shopCustomerId: customerId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.customerOldBalance = Number(
              res.data.balance.split(",").join("")
            );
            this.newPayment.customerBalance = this.customerOldBalance;
            if (this.newPayment.customerBalance > 0) {
              this.newPayment.customerBalance =
                this.newPayment.customerBalance.toLocaleString() +
                " ریال بدهکار";
            } else if (this.newPayment.customerBalance < 0) {
              this.newPayment.customerBalance =
                Math.abs(this.newPayment.customerBalance).toLocaleString() +
                " ریال بستانکار";
            } else {
              this.newPayment.customerBalance = "تسویه";
            }
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    addPayment() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/payments/new",
        {
          shopCustomerId: this.newPayment.shopCustomerId,
          totalCost: this.newPayment.totalCost,
          paymentType: this.newPayment.paymentTypes,
          chequeNo: this.check.number ? this.check.number : "",
          chequeDate: this.check.date ? this.check.date : "",
          chequeSayyad: this.check.chequeSayyad ? this.check.chequeSayyad : "",
          chequeBank: this.check.bankName ? this.check.bankName : "",
          description: this.newPayment.description
            ? this.newPayment.description
            : "",
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.newPaymentDialog = false;
            this.customerNewBalance =
              this.customerOldBalance - Number(this.newPayment.totalCost);
            console.log(this.customerNewBalance);
            if (this.customerNewBalance > 0) {
              this.customerNewBalance =
                this.customerNewBalance.toLocaleString() + " ریال بدهکار";
            } else if (this.customerNewBalance < 0) {
              this.customerNewBalance =
                Math.abs(this.customerNewBalance).toLocaleString() +
                " ریال بستانکار";
            } else {
              this.customerNewBalance = "تسویه";
            }
            console.log(this.customerNewBalance);
            setTimeout(() => {
              this.printReceipt("new");
            }, 500);
            this.searchPayments();
            // this.newPayment = {};
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.isBusy = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading = false;
          this.isBusy = false;
        });
    },
    printReceipt(status) {
      //printing receipt
      var myWindow = window.open("#", "Receipt", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;} table, td, th {border: 1px solid black} tr{ page-break-inside:avoid; page-break-after:auto } thead { display: table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title>Receipt</title>"
      );
      myWindow.document.write("</head><body>");
      if (status == "new") {
        myWindow.document.write(document.getElementById("Receipt").innerHTML);
      } else {
        myWindow.document.write(
          document.getElementById("oldReceipt").innerHTML
        );
      }

      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    editCustomer() {
      this.progress = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customer/edit",
        {
          shopCustomerId: this.selected,
          name: this.customer.name,
          mobile: this.customer.mobile,
          email: this.customer.email,
          economicCode: this.customer.economicCode,
          phone: this.customer.phone,
          address: this.customer.address,
          natCode: this.customer.natCode,
          type: this.customer.type,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.customerDialog = false;
            this.isBusy = true;
            this.customerName = "";
            this.customerPriority = "";
            this.customerEmail = "";
            this.customerMobile = "";
            this.searchPayments();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.customerDialog = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },
    getCustomerInfo() {
      this.progress = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customer/getInfo",
        {
          shopCustomerId: this.selected,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          console.log(res.data.name);
          if (res.status == 200) {
            this.customer.name = res.data.name;
            this.customer.mobile = res.data.mobile;
            this.customer.email = res.data.email;
            this.customer.economicCode = res.data.economicCode;
            this.customer.phone = res.data.phone;
            this.customer.address = res.data.address;
            this.customer.natCode = res.data.natCode;
            this.customer.type = res.data.type;
            this.customer.balance = res.data.balance;
            this.progress = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    searchPayments() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/payments/incomes",
        {
          startDate: this.startDate + "00:00",
          endDate: this.endDate + "23:59",
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.payments = res.data;
            this.TotalRows = this.payments.length;
            this.vLoading = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.vLoading = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
          this.vLoading = false;
        });
    },
    getCustomers() {
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customers/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.customers = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
  },

  mounted() {
    this.searchPayments();
    this.getCustomers();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
